import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52b4ea4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import LeftMenuSidebar from "../sidebars/LeftMenuSidebar.vue";
import TopLogoSidebar from "../sidebars/TopLogoSidebar.vue";
import {useSidebarStore} from "@/store/sidebar/sidebar";


export default /*#__PURE__*/_defineComponent({
  __name: 'InnerPageLayout',
  setup(__props) {

const sidebarStore = useSidebarStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopLogoSidebar),
    _createElementVNode("div", null, [
      _createVNode(LeftMenuSidebar),
      _createElementVNode("div", {
        class: _normalizeClass(['container', _unref(sidebarStore).isOpen ? 'container--sidebar-open' : 'container--sidebar-close'])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ]))
}
}

})